import { shoppingCartQtyReplace } from "./shoppingCartQtyReplace";
import { storeShoppingCart } from "./storeShoppingCart";

export const handleCartChangeQty = (shoppingCartString: string, productId: string, newQty: string, setStateFn: Function): void => {
  const newShopingCartString = shoppingCartQtyReplace(shoppingCartString, productId, Number(newQty));
  setStateFn(newShopingCartString);
  storeShoppingCart(newShopingCartString);
}